import {
  ICliente,
  IClientexdel,
  IDelegacion,
  IPuntoServicio,
  IUsuarioCrear,
  IUsuarioModif,
} from "@/entities";

export class Clientexdel implements IClientexdel {
  active: boolean;
  cliente: ICliente;
  delegacion: IDelegacion;
  fecCrear: string;
  fecModif: string;
  id: number;
  numLimite: number;
  puntosservicio: IPuntoServicio[];
  usuarioCrear: IUsuarioCrear;
  usuarioModif: IUsuarioModif;

  constructor() {
    this.active = false;
    this.delegacion = {} as IDelegacion;
    this.cliente = {} as ICliente;
    this.fecCrear = "";
    this.fecModif = "";
    this.id = 0;
    this.numLimite = 0;
    this.puntosservicio = [];
    this.usuarioCrear = {} as IUsuarioCrear;
    this.usuarioModif = {} as IUsuarioModif;
  }
}
